// src/utils/transliterate.ts

export const latinToCyrillic = (input: string) => {
  const map: { [key: string]: string } = {
    sht: 'щ',
    sh: 'ш',
    ch: 'ч',
    ts: 'ц',
    ya: 'я',
    yu: 'ю',
    a: 'а',
    b: 'б',
    v: 'в',
    g: 'г',
    d: 'д',
    e: 'е',
    zh: 'ж',
    z: 'з',
    i: 'и',
    y: 'й',
    k: 'к',
    l: 'л',
    m: 'м',
    n: 'н',
    o: 'о',
    p: 'п',
    r: 'р',
    s: 'с',
    t: 'т',
    u: 'у',
    f: 'ф',
    h: 'х',
    c: 'ц',  // 'c' to 'ц'
    q: 'я',  // 'q' to 'я'
    j: 'ж',  // 'j' to 'ж'
  };

  // Match multi-character sequences first
  return input
    .replace(/sht/g, map['sht'] ?? 'sht')
    .replace(/sh/g, map['sh'] ?? 'sh')
    .replace(/ch/g, map['ch'] ?? 'ch')
    .replace(/ts/g, map['ts'] ?? 'ts')
    .replace(/ya/g, map['ya'] ?? 'ya')
    .replace(/yu/g, map['yu'] ?? 'yu')
    .split('')
    .map((char) => map[char] || char)
    .join('');
};

export const cyrillicToLatin = (input: string) => {
  const map: { [key: string]: string } = {
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ж: 'j',
    з: 'z',
    и: 'i',
    й: 'y',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'h',
    ц: 'c',
    ч: 'ch',
    ш: 'sh',
    щ: 'sht',
    ю: 'yu',
    я: 'ya',
  };

  return input
    .split('')
    .map((char) => map[char] || char)
    .join('');
};
